import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import { withApollo } from 'react-apollo';
import classnames from 'classnames';

import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ErrorNotification from '../../components/common/ErrorNotification';

import combineStyles from '../../utils/combineStyles';
import LayoutStyles from '../../styles/layout';
import ButtonStyles from '../../styles/button';
import TypographyStyles from '../../styles/typography';
import SpacingStyles from '../../styles/helpers/spacing';
import CustomFieldsIndexStyles from './CustomFieldsIndex.styles.js';

import PagesDefinition from './PagesDefinition';
import ShipmentReferencesTable from '../../components/customFields/ShipmentReferencesTable';
import ShipmentReferenceForm from '../../components/customFields/ShipmentReferenceForm';
import ShipmentReferenceModel from '../../Models/ShipmentReference';

import { sanitize as sanitizeShipmentReference } from '../../Models/ShipmentReference';
import * as ShipmentReferenceMutations from '../../graphQL/mutations/customFields';
import _cloneDeep from 'lodash/cloneDeep';

export class CustomFieldsIndex extends Component {
  state = {
    customField: {},
    pageOpened: PagesDefinition.ShipmentReferences,
    openForm: false,
    changedUtc: null,
    isSubmitting: false
  };

  _handleAddCustomField = () => {
    this.setState({
      customField: { ...this._getNewCustomField() },
      openForm: true
    });
  };

  _handleCloseForm = () => {
    this.setState({ openForm: false });
  };

  _handleRowClick = customField => {
    this.setState({ customField: _cloneDeep(customField), openForm: true });
  };

  _getNewCustomField = () => {
    //TODO implement swith case when the other custom fields are enabled
    // switch (this.state.pageOpened) {
    // case PagesDefinition.ShipmentReferences:
    //
    // default:
    //
    // }
    return { ...ShipmentReferenceModel() };
  };

  _handleSaveShipmentReference = async values => {
    try {
      this.setState({ isSubmitting: true });
      const mutation = values.isNew
        ? ShipmentReferenceMutations.create
        : ShipmentReferenceMutations.update;

      const { client: ApolloClient } = this.props;
      await ApolloClient.mutate({
        mutation: mutation,
        variables: {
          customField: {
            ...sanitizeShipmentReference(values)
          }
        }
      });
      this.setState({ changedUtc: new Date().getTime() });
    } catch (errorsOnSave) {
      this.setState({
        errorsOnSave
      });
      throw errorsOnSave;
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  handleChange = (_event, value) => this.setState({ pageOpened: value });

  render() {
    const { t, classes } = this.props;
    const { pageOpened } = this.state;

    return (
      <div>
        <div className={classes.titleWrapper}>
          <h1
            className={classnames(
              classes.headline4,
              classes.noMarginBottom,
              classes.title
            )}
          >
            {t('Custom Fields')}
          </h1>
          {pageOpened === PagesDefinition.ShipmentReferences && (
            <Button
              className={classes.button}
              classes={{
                label: classes.buttonLabel
              }}
              variant="contained"
              color="primary"
              onClick={this._handleAddCustomField}
            >
              {t('Add Shipment Reference')}
            </Button>
          )}
        </div>
        <div className={classes.tabsContainer}>
          <Tabs
            value={pageOpened}
            onChange={this.handleChange}
            classes={{
              indicator: classes.tabsIndicator,
              scroller: classes.tabsScroller
            }}
          >
            <Tab
              label={t('Shipment References')}
              classes={{
                root: classes.tabRoot,
                label: classnames(classes.headline6, classes.tabLabel),
                selected: classes.tabLabelSelected,
                labelContainer: classes.tabLabelContainer
              }}
            />
          </Tabs>
        </div>
        <Fragment>
          {pageOpened === PagesDefinition.ShipmentReferences && (
            <ShipmentReferencesTable
              changedUtc={this.state.changedUtc}
              onRowClick={this._handleRowClick}
            />
          )}
        </Fragment>
        <ShipmentReferenceForm
          open={
            this.state.openForm &&
            pageOpened === PagesDefinition.ShipmentReferences
          }
          onClose={this._handleCloseForm}
          onSave={this._handleSaveShipmentReference}
          isSubmitting={this.state.isSubmitting}
          shipmentReference={this.state.customField}
        />
        {this.state.errorsOnSave && (
          <ErrorNotification message={this.state.errorsOnSave.message} />
        )}
      </div>
    );
  }
}

const CustomFieldsIndexWithTranslation = withNamespaces()(CustomFieldsIndex);

export default withStyles(
  combineStyles(
    LayoutStyles,
    ButtonStyles,
    TypographyStyles,
    SpacingStyles,
    CustomFieldsIndexStyles
  )
)(withApollo(CustomFieldsIndexWithTranslation));
